import React from 'react';
import TreeLogo from './TreeLogo';

const linkedinUrl = 'https://www.linkedin.com/in/krish-gupta-b173b6172/';
const githubUrl = 'https://github.com/Kilo-zolo/';
const contactEmail = 'krish.gupta@zohtek.com';

const Footer = () => (
  <footer
    style={{
      background: '#05070a',
      borderTop: '1px solid rgba(255,255,255,0.08)',
    }}
  >
    <div
      className="zk-section-gutter"
      style={{ maxWidth: '1180px', margin: '0 auto', padding: '56px 56px 40px' }}
    >
      <div
        style={{
          display: 'flex',
          flexWrap: 'wrap',
          alignItems: 'center',
          justifyContent: 'space-between',
          gap: '24px',
          paddingBottom: '32px',
          borderBottom: '1px solid rgba(255,255,255,0.07)',
        }}
      >
        <div data-zk-static-logo style={{ position: 'relative', display: 'flex', alignItems: 'center', gap: '11px' }}>
          <TreeLogo gradientId="zk-footer-grad" />
          <span
            style={{
              position: 'relative',
              zIndex: 1,
              display: 'inline-block',
              width: '9px',
              height: '9px',
              borderRadius: '50%',
              background: '#ff3ea5',
              boxShadow: '0 0 12px #ff3ea5',
            }}
          />
          <span
            style={{
              position: 'relative',
              zIndex: 1,
              fontWeight: 700,
              fontSize: '20px',
              letterSpacing: '0.17em',
            }}
          >
            ZOHTEK
          </span>
        </div>
        <div
          style={{
            fontFamily: 'var(--zk-mono)',
            fontSize: '12px',
            letterSpacing: '0.18em',
            color: '#38e0ff',
            textTransform: 'uppercase',
          }}
        >
          Innovate · Empower · Evolve
        </div>
      </div>

      <div
        style={{
          display: 'flex',
          flexWrap: 'wrap',
          alignItems: 'center',
          gap: '10px 16px',
          marginTop: '28px',
          fontFamily: 'var(--zk-mono)',
          fontSize: '12px',
          color: 'rgba(232,238,240,0.55)',
        }}
      >
        <span>Zohtek Pty Ltd</span>
        <span style={{ opacity: 0.35 }}>·</span>
        <span>ABN 34 641 696 595</span>
        <span style={{ opacity: 0.35 }}>·</span>
        <span>Melbourne, Australia</span>
        <span style={{ opacity: 0.35 }}>·</span>
        <a href={`mailto:${contactEmail}`} style={{ color: 'rgba(232,238,240,0.7)', textDecoration: 'none' }}>
          {contactEmail}
        </a>
        <span style={{ opacity: 0.35 }}>·</span>
        <a href={linkedinUrl} target="_blank" rel="noopener noreferrer" aria-label="LinkedIn" className="zk-social zk-social--footer">
          <svg width="17" height="17" viewBox="0 0 24 24" fill="currentColor">
            <path d="M20.45 20.45h-3.56v-5.57c0-1.33-.02-3.04-1.85-3.04-1.85 0-2.14 1.45-2.14 2.94v5.67H9.35V9h3.42v1.56h.05c.48-.9 1.64-1.85 3.37-1.85 3.6 0 4.27 2.37 4.27 5.46v6.28zM5.34 7.43a2.07 2.07 0 1 1 0-4.14 2.07 2.07 0 0 1 0 4.14zM7.12 20.45H3.56V9h3.56v11.45zM22.22 0H1.77C.79 0 0 .77 0 1.73v20.54C0 23.23.79 24 1.77 24h20.45c.98 0 1.78-.77 1.78-1.73V1.73C24 .77 23.2 0 22.22 0z" />
          </svg>
        </a>
        <a href={githubUrl} target="_blank" rel="noopener noreferrer" aria-label="GitHub" className="zk-social zk-social--footer">
          <svg width="17" height="17" viewBox="0 0 24 24" fill="currentColor">
            <path d="M12 .5C5.37.5 0 5.78 0 12.29c0 5.21 3.44 9.63 8.21 11.19.6.11.82-.25.82-.56 0-.28-.01-1.02-.02-2-3.34.71-4.04-1.58-4.04-1.58-.55-1.37-1.34-1.73-1.34-1.73-1.09-.73.08-.72.08-.72 1.2.08 1.84 1.21 1.84 1.21 1.07 1.8 2.81 1.28 3.5.98.11-.76.42-1.28.76-1.57-2.67-.3-5.47-1.31-5.47-5.83 0-1.29.47-2.34 1.24-3.17-.12-.3-.54-1.52.12-3.17 0 0 1.01-.32 3.3 1.21a11.5 11.5 0 0 1 3-.4c1.02 0 2.05.14 3 .4 2.29-1.53 3.3-1.21 3.3-1.21.66 1.65.24 2.87.12 3.17.77.83 1.24 1.88 1.24 3.17 0 4.53-2.81 5.53-5.49 5.82.43.37.81 1.1.81 2.22 0 1.6-.01 2.89-.01 3.28 0 .31.21.68.83.56C20.56 21.91 24 17.5 24 12.29 24 5.78 18.63.5 12 .5z" />
          </svg>
        </a>
      </div>

      <p
        style={{
          margin: '28px 0 0',
          maxWidth: '620px',
          fontSize: '12.5px',
          lineHeight: 1.6,
          color: 'rgba(232,238,240,0.4)',
          textWrap: 'pretty',
        }}
      >
        Zohtek acknowledges the Traditional Owners of the land on which we work, and pays respect to Elders past and present.
      </p>
    </div>
  </footer>
);

export default Footer;
